import type { Mode } from 'core/domain/Mode'

import type { AccessorialOption } from '../../domain/ShipmentCharges'
import { useShipmentChargeTypes } from './useShipmentChargeTypes'

export function useShipmentAccessorialsOptions(mode: Mode): {
  accessorialsOptions: Array<AccessorialOption>
} {
  const { shipmentChargeTypes } = useShipmentChargeTypes({ mode, enabled: true })

  return { accessorialsOptions: shipmentChargeTypes }
}
